import React, { Component } from "react";
import { connect } from "react-redux";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import FormHelperText from "@material-ui/core/FormHelperText";
import { OutlinedInput } from "@material-ui/core";
import { StylesProvider } from "@material-ui/core";
import "./iframe.scss";
import "./chat.scss";
import tinycolor from "tinycolor2";
import ReCAPTCHA from "react-google-recaptcha";
import UserInfo from "../../services/user-info";
import { initConversation } from "../../actions/app";
import clientWidgetConfig from "../../services/client-config";
import Load from '../load/Load'
import AuthenticationService from '../../services/authentication-service'
import { toggleModalChat } from '../../actions/app';
import { uuid as uuidv4 } from 'uuidv4'
import { getUser } from '../../actions/authentication'
import { clearUser } from '../../actions/authentication'



class ChatIntro extends Component {
  userInfo = UserInfo.getInfo();
  state;
  externalWindow;

  constructor() {
    super();
    const userDataDom = document.getElementById("omni-chat-script");
    this.state = {
      verified: false,
      alreadyGettedToken: false,
      showSSOIframe: false,
      clientIframeUrl: null,
      code: userDataDom ? userDataDom.getAttribute("data-code") : null,
      token: null,
      login: "",
      password: "",
      userName: userDataDom ? userDataDom.getAttribute("data-username") : "Usuário",
      cpf: "",
      sysId: userDataDom ? userDataDom.getAttribute("data-userid") : null,
      userHash: userDataDom ? userDataDom.getAttribute("data-userhash") : null,
      environment: userDataDom ? userDataDom.getAttribute("data-env") : "dev",
      tenant: userDataDom ? userDataDom.getAttribute("data-tenant") : null,
      clientId: userDataDom ? userDataDom.getAttribute("data-client") : null,
      isShowedGovLogin: false,
      isOpenLogin: false,
      loading: false,
      parsedWelcomeMessage: '',
      appBrowserClosed: false
    };
  }



  async getUserToken() {
    let clientToken = null;
    const clientCode =
      this.state.code === "undefined" ||
        this.state.code === "null" ||
        this.state.code === ""
        ? null
        : this.state.code;

    if (this.state.tenant === "yara" && !this.state.alreadyGettedToken) {
      clientToken = await clientWidgetConfig["yara"].getUserToken(
        window.location.href,
        clientCode,
        this.state.sysId,
        this.state.userHash,
        this.state.environment
      );
      this.setState({
        ...this.state,
        alreadyGettedToken: true,
        token: clientToken && clientToken.result ? clientToken.result : null,
        showSSOIframe: clientToken && clientToken.showSSOIframe ? true : false,
        clientIframeUrl:
          clientToken && clientToken.showSSOIframe ? clientToken.url : null,
      });
    }
  }

  handleInit(formUserData, custom = false) {
    // Bug: #93588
    localStorage.removeItem("auth")

    if (this.props.config.isCaptchaActive && !this.state.verified) {
      return false;
    }
    const userData = {
      user_id: formUserData ? formUserData.user_id : "",
      user_token: this.state.token
        ? this.state.token
        : formUserData
          ? formUserData.user_token
          : "",
      userName: this.state.userName ? this.state.userName : "",
      cpf: this.state.cpf,
      sysId: this.state.sysId,
    };

    // Bug: #93588
    if (custom && this.props.config.isGovAuthEnable) {
      userData.cpf = formUserData.cpf
      userData.userName = formUserData.userName
      localStorage.setItem("auth", formUserData.authenticated);
    }
    localStorage.setItem("userName", userData.userName);
    localStorage.setItem("cpf", userData.cpf);
    localStorage.setItem("user_id", userData.user_id);
    localStorage.setItem("user_sysId", userData.sysId);
    localStorage.setItem("user_token", userData.user_token);
    this.props.initConversation(userData);
  }

  getButtons(buttonStyles) {
    /* @martini - 2020-11-13
    Não iremos realizar a chamada do token nesse momento para
    não gerar solicitação de autenticação do usuário.
    Ver task 43608 no DevOps projeto 0087

    fn que gera o token
    this.getUserToken();
    */

    let isDisabled =
      this.props.config.isCaptchaActive &&
      !this.state.verified &&
      (!this.state.userName || this.state.userName === "");
    let buttonStyle = !isDisabled
      ? buttonStyles
      : { opacity: 0.5, cursor: "initial", ...buttonStyles };
    let startButton = (
      <button
        title='Iniciar Conversa'
        disabled={isDisabled}
        className="init-button"
        onClick={(e) => this.handleInit()}
        style={buttonStyle}
      >
        Iniciar conversa
      </button>
    );
    let logoImage = this.props.config.isDisplayedLogo ? (
      <img
        title={`Logo ${this.props.config.tenantName}`}
        src={this.props.config.welcomeImageUrl}
        className="logo"
        alt="Logo Cognitive Assistant"
      />
    ) : null;
    if (this.props.config.isWelcomeFormActive) {
      const correctLengthCPF = this.state.cpf.length >= 11;
      const validCPF = this.validateCPF(this.state.cpf);
      const validName = this.state.userName && this.state.userName.length > 0;
      const passedCaptcha =
        !this.props.config.isCaptchaActive || this.state.verified;
      isDisabled = !(
        correctLengthCPF &&
        passedCaptcha &&
        validCPF &&
        validName
      );
      buttonStyle = isDisabled
        ? { opacity: 0.5, cursor: "initial", ...buttonStyles }
        : buttonStyles;

      const isLogged = new AuthenticationService().logged
      let customFields;

      if (isLogged && !this.state.isShowedGovLogin && this.props.config.isGovAuthEnable) {
        console.log('isLogged, !this.state.isShowedGovLogin')
        customFields = this.renderCustomFieldsLogged(correctLengthCPF, validCPF, buttonStyles)
      } else {
        console.log('notLogged')
        customFields = this.renderCustomFields(correctLengthCPF, validCPF) //generateSnippetWithGovLogin
      }
      startButton = (

        // <div className="container-buttons">
        // <StylesProvider injectFirst={true}>
        <div className="form-control-button">
          <button
            title='Iniciar Atendimento'
            disabled={isDisabled}
            className="br-button omni-button"
            type="button"
            onClick={(e) =>
              this.handleInit.bind(this)({
                userName: this.state.userName,
                cpf: this.state.cpf,
                user_token: this.state.token,
                user_id: this.state.sysId,
              })
            }
            style={{ backgroundColor: buttonStyles.backgroundColor }}
          >
            Iniciar Atendimento
          </button>
        </div>
      );
      logoImage = this.props.config.isDisplayedLogo ? (
        <img
          title={`Logo ${this.props.config.tenantName}`}
          src={this.props.config.welcomeImageUrl}
          className="logo"
          alt="Logo Cognitive Assistant"
        />
      ) : null;
      return (
        <>
          {" "}
          {customFields}
          <div className="start-buttons-container">
            {this.renderButton(startButton)}
            {this.showGovButton() && this.govLoginButton(buttonStyles)}
          </div>
          <div>
            {logoImage}{" "}
            <div
              hidden={!this.props.config.isCustomizedFooter}
              className="text-link-inner"
            >
              <span className="footer-text">{this.props.config.footerText}</span>
            </div>
          </div>
        </>
      );
    }

    if (!this.props.config.isChannelActive) {
      return (
        <span className="chat-disabled-message">
          {this.props.config.disabledMessage}
        </span>
      );
    }

    if (this.props.config.isCaptchaActive) {
      return (
        <div>
          <div className="recaptcha-and-logo">
            {logoImage}
            {this.props.config.isCaptchaActive ? this.getCaptcha() : false}
          </div>
          {startButton}
        </div>
      );
    }

    return (
      <div>
        {startButton}
        {logoImage}
      </div>
    );
  }

  renderCustomFields(correctLengthCPF, validCPF) {
    return this.generateSnippetDefault(correctLengthCPF, validCPF)
  }

  renderButton(startButton) {
    const isLogged = new AuthenticationService().logged

    if (this.state.isShowedGovLogin && isLogged) {
      return startButton
    }

    else if (!this.props.config.isGovAuthEnable && !this.props.config.isGovAuthEnableLogged) {
      return startButton
    }

    else if (isLogged && this.props.config.isGovAuthEnableLogged && this.props.config.isGovAuthEnable) {
      return null
    }

    else {
      return startButton
    }
  }

  generateSnippetDefault = (correctLengthCPF, validCPF) => {
    const fields = (
      <div id="omni-chat" className="form-inss">
        <FormControl variant="outlined">
          <InputLabel htmlFor="userNameForm">Digite seu nome</InputLabel>
          <OutlinedInput
            labelWidth={130}
            type="text"
            onChange={this.handleChangeUserName.bind(this)}
            id="userNameForm"
          />
          <FormHelperText id="userNameForm-helper-text"></FormHelperText>
        </FormControl>
        <FormControl error={correctLengthCPF && !validCPF} variant="outlined">
          <InputLabel htmlFor="cpf">Digite seu CPF</InputLabel>
          <OutlinedInput
            labelWidth={130}
            type="text"
            onChange={this.handleChangeCpf.bind(this)}
            id="cpf"
          />
          <FormHelperText id="cpf-helper-text">
            {correctLengthCPF && !validCPF ? "CPF Inválido" : ""}
          </FormHelperText>
        </FormControl>
      </div>
    );
    return fields
  }

  showGovButton() {
    const isLogged = new AuthenticationService().logged
    if (!isLogged && this.props.config.isGovAuthEnable && this.props.config.isGovAuthEnableNotLogged) {
      return true
    }
  }

  renderCustomFieldsLogged(correctLengthCPF, validCPF, buttonStyles) {
    const isLogged = new AuthenticationService().logged
    if (isLogged && this.props.config.isGovAuthEnable && this.props.config.isGovAuthEnableLogged) {
      return this.generateSnippetLogged(buttonStyles)
    } else {
      return this.generateSnippetDefault(correctLengthCPF, validCPF)
    }
  }
  generateSnippetLogged = (buttonStyles) => {
    const fields = (
      <div className="container-buttons">
        <StylesProvider injectFirst={true}>
          <div className="form-control-button">
            <button
              className="br-button omni-button"
              type="button"
              aria-label="Iniciar Atendimento"
              style={{ backgroundColor: buttonStyles.backgroundColor }}
              onClick={this.handleOpenGovLogin}
            >
              Iniciar Atendimento
            </button>
          </div>
        </StylesProvider>
      </div>
    );

    return fields
  }

  govLoginButton = (buttonStyles) => {
    const fields = (
      <>
        <div className="govbr-or-text">
          <span className="govbr-or-line"></span>
          <span>Ou</span>
          <span className="govbr-or-line"></span>
        </div>
        <p className="govbr-text">
          {this.props.config.govbrText}
        </p>
        <div className="container-buttons mb-0">
          <div className="form-control-button">
            <button
              title="Entrar com o Gov br"
              className="br-button omni-button gov-button"
              type="button"
              aria-label="Entrar com o Gov br"
              style={{ backgroundColor: buttonStyles.backgroundColor }}
              onClick={this.handleOpenGovLogin}
            >
              <img id="govbr-img" alt="Entrar via GovBr" src="https://sso.acesso.gov.br/assets/govbr/img/govbr.png" />
            </button>
          </div>
        </div>
      </>
    );

    return fields
  }

  handleOpenGovLogin = () => {
    this.setState({
      appBrowserClosed: false
    })
    localStorage.removeItem('omni_ifs_auth');
    localStorage.removeItem('omni_ifs_ts');

    const state = uuidv4();
    const redirect_uri = this.props.config.redirectUri
    const client_id = this.props.config.clientId
    const urlLoginPrefix = this.props.config.urlSso
    const response_type = this.props.config.responseType
    const url = `${urlLoginPrefix}?response_type=${response_type}&client_id=${encodeURIComponent(client_id)}&redirect_uri=${encodeURIComponent(redirect_uri)}&nonce=${uuidv4()}&state=${state}`
    let externalWindow = "";
    let code = ""
    let thisClass = this
    const isMobile = this.userInfo.isMobile;
    const isApp = localStorage.getItem('ifs_platform') === 'cordova';
    console.log(`[handleOpenGovLogin] => isMobile =${isMobile} isApp=${isApp}`)
    if (isMobile && isApp) {
      externalWindow = window.open(url, 'janela', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800,beforeload=get');
    } else {
      externalWindow = window.open(url, 'janela', 'toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,width=800,height=800');
    }
    if (externalWindow) {
      if (isMobile && isApp) {
        console.log('[externalWindow, isMobile, isApp ]')
        externalWindow.addEventListener('beforeload', async (params, callback) => {
          code = new URL(params.url).searchParams.get('code')
          if (params.url.indexOf('digital/authorize') !== -1) {
            await new AuthenticationService().send(code, state).then(async () => {
              await thisClass.props.getUser(state)
            }).catch((error) => {
              console.log(`[addEventListener  beforeload condition digital/authorize error ${JSON.stringify(error)}]`)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            })
          }
          callback(params.url)
        });
        var timerMobile = setInterval(async function () {
          setTimeout(async () => {
            console.log(`[setTimeout  externalWindow condition ${JSON.stringify(thisClass.props.user)}]`)
            if (Object.keys(thisClass.props.user).length !== 0 && thisClass.props.user.type === 'Success') {
              console.log('[setTimeout  externalWindow condition - Success]')
              clearInterval(timerMobile)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            } else if (Object.keys(thisClass.props.user).length !== 0 && thisClass.props.user.type === 'sessionNotFound') {
              await new AuthenticationService().send(code, state).then(
                async () => {
                    await thisClass.props.getUser(state)
                }
              ).catch((error) => {
                console.log(`[setTimeout  externalWindow condition - sessionNotFound error ${JSON.stringify(error)}]`)
                externalWindow.close()
                clearInterval(timerMobile)
                thisClass.setState({
                  appBrowserClosed: true
                })
              })
              console.log('[setTimeout  externalWindow condition - sessionNotFound]')
              clearInterval(timerMobile)
              externalWindow.close()
              thisClass.setState({
                appBrowserClosed: true
              })
            }
          }, 2000)
        }, 3000);
        externalWindow.addEventListener('exit', () => {
          setTimeout(() => {
            thisClass.closeLoading()
            clearInterval(timerMobile)
          }, 4000)
        })
      } else {
        var timer = setInterval(function () {
          if (externalWindow.closed) {
            clearInterval(timer)
            thisClass.props.getUser(state)
          }
        }, 500);
      }
    }

    /**
     * To get user data after getUser
     */
    const newPopupIntervalId = setInterval(() => {
      if (externalWindow.closed || this.state.appBrowserClosed) {
        if (thisClass.props.user === null) {
          const text = (<div><p style={{ whiteSpace: 'pre-wrap' }}>{thisClass.props.config.errorLogin}</p></div>)
          thisClass.handleOpenModal(text)
          thisClass.closeLoading()
          clearInterval(newPopupIntervalId);
          thisClass.props.clearUser()
          this.setState({ parseWelcomeMessage: this.props.config.welcomeTextLogin })
        } else {
          if (thisClass.props.user.hasOwnProperty('name') && thisClass.props.user.hasOwnProperty('cpf')) {
            thisClass.closeLoading()
            clearInterval(newPopupIntervalId);
            const user = thisClass.props.user
            const auth = new AuthenticationService()
            auth.setToken()
            auth.setExpiration()
            // To calling init chat function
            thisClass.handleInit.bind(thisClass)({
              userName: user.name,
              cpf: user.cpf,
              user_token: this.state.token,
              user_id: this.state.sysId,
              authenticated: "govbr"
            }, true)
          } else {
            if (Object.keys(thisClass.props.user).length > 0) {
              if (thisClass.props.user.type === 'embededSeals') {
                const text = (<div><p style={{ whiteSpace: 'pre-wrap' }}>{thisClass.props.config.reliabilitysInvalid}</p></div>)
                thisClass.handleOpenModal(text)
                thisClass.closeLoading()
                this.setState({ parsedWelcomeMessage: this.props.config.welcomeTextLogin })
              } else {
                const text = (<div><p style={{ whiteSpace: 'pre-wrap' }}>{thisClass.props.config.errorLogin}</p></div>)
                thisClass.handleOpenModal(text)
                thisClass.closeLoading()
                this.setState({ parsedWelcomeMessage: this.props.config.welcomeTextLogin })
              }
              clearInterval(newPopupIntervalId);
              thisClass.props.clearUser()
            }
          }
        }
      }
    }, 500);

    this.setIsShowedGovLogin()
  }

  handleOpenModal(message = '') {
    this.props.toggleModalChat(true, message, () => null, () => null);
  }

  handleCloseGovLogin = () => {
    this.setIsClosedGovLogin()
  }

  setIsClosedGovLogin = () => {
    this.setState({
      isShowedGovLogin: true
    })
  }

  setIsShowedGovLogin = () => {
    this.setState({
      isShowedGovLogin: true,
      loading: true,
      isOpenLogin: true,
    })
  }

  closeLoading = () => {
    this.setState({
      loading: false
    })
  }

  handleChangeCaptcha = (e) => {
    this.setState({
      ...this.state,
      verified: true,
    });
  };

  getHeaderColors = () => {
    if (this.props.config.headerColor) {
      document.documentElement.style.setProperty('--header-color', this.props.config.headerColor);
    }
    const color = getComputedStyle(document.documentElement).getPropertyValue('--header-color');
    const header = tinycolor(color);
    return {
      color: header.getLuminance() > 0.5 ? "#333333" : "#F1f1f1"
    };
  }

  getCaptcha() {
    if (!this.props.config.isCaptchaActive) return false;
    const captcha = React.createRef();
    return (
      <div className="captcha-resize">
        <ReCAPTCHA
          ref={captcha}
          size={this.userInfo.isMobile ? "compact" : "normal"}
          sitekey="6LdjR4YUAAAAAFhZq5RZADsefDzCydPy3mC36dxj"
          onChange={this.handleChangeCaptcha}
        />
      </div>
    );
  }
  validateLoginForm() {
    return this.state.login.length > 0 && this.state.password.length > 0;
  }

  handleChangeUserName(e) {
    this.setState({ userName: e.target.value });
  }

  handleChangeCpf(e) {
    e.target.FormHelperText = "error no CPF!!";
    e.target.value = e.target.value
      .replace(/\D/g, "") // substitui qualquer caracter que nao seja numero por nada
      .replace(/(\d{3})(\d)/, "$1.$2") // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})/, "$1-$2")
      .replace(/(-\d{2})\d+?$/, "$1");

    this.setState({ cpf: e.target.value.replace(/\D/g, "") });
  }

  validateCPF(strCPF) {
    let soma = 0;
    let resto = 0;
    let i = 0;

    for (i = 1; i <= 9; i++)
      soma = soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(strCPF.substring(9, 10))) return false;

    soma = 0;
    for (i = 1; i <= 10; i++)
      soma = soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i);
    resto = (soma * 10) % 11;

    if (resto === 10 || resto === 11) resto = 0;
    if (resto !== parseInt(strCPF.substring(10, 11))) return false;
    return true;
  }
  handleChangeLogin = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };
  handleChangePassword = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
  };

  parseWelcomeMessage(welcome, userName, assistantName) {
    let message = welcome;
    if (message.includes("#{user_name}")) {
      message = message.replace(
        "#{user_name}",
        userName
          ? userName
          : localStorage.getItem("userName")
            ? localStorage.getItem("userName")
            : "Colaborador"
      );
    }
    if (message.includes("#{botName}")) {
      message = message.replace(
        "#{botName}",
        assistantName ? assistantName : "bot"
      );
    }
    return message;
  }

  handleIframeRedirect(iframeId) {
    function iframeURLChange(iframe, callback) {
      const unloadHandler = () => {
        setTimeout(() => {
          if (
            !iframe ||
            !iframe.contentWindow ||
            !iframe.contentWindow.location
          ) {
            return;
          }
          if (iframe.contentWindow.location.href.includes("?code=")) {
            iframe.removeEventListener("load", attachUnload);
            iframe.contentWindow.removeEventListener("unload", unloadHandler);
          }
          callback(iframe.contentWindow.location.href);
        }, 0);
      };

      function attachUnload() {
        // Remove the unloadHandler in case it was already attached.
        // Otherwise, the change will be dispatched twice.
        iframe.contentWindow.removeEventListener("unload", unloadHandler);
        iframe.contentWindow.addEventListener("unload", unloadHandler);
      }
      iframe.addEventListener("load", attachUnload);
      attachUnload();
    }

    iframeURLChange(document.getElementById(iframeId), (newURL) => {
      if (newURL.includes("?code=")) {
        const url = newURL.split("?code=")[1];
        this.setState({
          ...this.state,
          showSSOIframe: false,
          code: url.includes("&") ? url.split("&")[0] : url,
        });
      }
    });
  }


  renderSSOIframe(iframeUrl) {
    const mainframe = (
      <iframe
        title="yara-client"
        className="iframe"
        id="clientIframe"
        src={iframeUrl}
      ></iframe>
    );
    if (this.state.alreadyGettedToken) {
      this.setState({
        ...this.state,
        alreadyGettedToken: false,
      });
    }
    return mainframe;
  }

  componentWillMount() {
    const isLogged = new AuthenticationService().logged
    let isGovAuthEnable = this.props.config.isGovAuthEnable
    let isGovAuthEnableLogged = this.props.config.isGovAuthEnableLogged
    let isGovAuthEnableNotLogged = this.props.config.isGovAuthEnableNotLogged

    if (!isGovAuthEnable) {
      this.setState({
        parsedWelcomeMessage: this.props.config.welcomeText
      })
      return
    }

    if (isLogged) {
      if (isGovAuthEnableLogged) {
        this.setState({
          parsedWelcomeMessage: this.parseWelcomeMessage(
            this.props.config.presentationAuth + '</br>' + this.props.config.loggedMessage,
            this.state.userName,
            this.props.config.assistantName)
        })
      } else {
        this.setState({
          parsedWelcomeMessage: this.props.config.welcomeText
        })
      }
      return
    } else {
      if (isGovAuthEnableNotLogged) {
        this.setState({
          parsedWelcomeMessage: this.props.config.presentationAuth + '</br>' + this.props.config.welcomeTextLogin
        })
      } else {
        this.setState({
          parsedWelcomeMessage: this.props.config.welcomeText
        })
      }
    }
  }

  createMarkup() {
    return { __html: 'First &middot; Second' };
  }

  renderOmniSnippet(buttonStyles) {
    return (
      <React.Fragment>
        {this.props.config.botAvatarUrl ? (
          <img
            title={`Logo ${this.props.config.assistantName}`}
            src={this.props.config.botAvatarUrl}
            className="avatar"
            alt="Assistente Virtual"
          />
        ) : null}
        <div className="chat-intro-content-wrapper">
          <div className="message" dangerouslySetInnerHTML={{ __html: this.state.parsedWelcomeMessage }} />
          {this.getButtons(buttonStyles)}
        </div>
      </React.Fragment>
    );
  }

  render() {
    const { app } = this.props;
    const buttonStyles = this.getHeaderColors();
    const chatIntroClassName = `chat-intro ${app.minimize ? "omni-hide" : ""}`;
    if (document.getElementById("clientIframe")) {
      this.handleIframeRedirect("clientIframe");
    }
    return (
      <div className={`${chatIntroClassName}${this.state.loading ? 'loading-container' : ''}`}>
        {this.state.showSSOIframe
          ? this.renderSSOIframe(this.state.clientIframeUrl)
          : (
            this.state.loading ?
              <Load />
              : this.renderOmniSnippet(buttonStyles)
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  config: state.config,
  app: state.app,
  user: state.authentication
});

const mapDispatchToProps = (dispatch) => ({
  clearUser: () => dispatch(clearUser()),
  getUser: async (state) => dispatch(await getUser(state)),
  initConversation: (config) => dispatch(initConversation(config)),
  toggleModalChat: (toggle, message, onConfirm, onClose) => dispatch(toggleModalChat(toggle, message, onConfirm, onClose)),

});

export default connect(mapStateToProps, mapDispatchToProps)(ChatIntro);
// export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ChatIntro));
